import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1240bf02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-2 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = {
  class: "h-fit bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 my-4",
  role: "alert"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-span-2 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 text-sm sm:text-base lg:text-sm xl:text-base" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold bg-gray-50 p-3 border-b-2" }, "Supported browsers"),
  /*#__PURE__*/_createElementVNode("div", { class: "block p-3 border-b-2" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.google.com/chrome/"
    }, "Chrome")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "block p-3 border-b-2" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://support.apple.com/downloads/safari"
    }, "Safari")
  ])
], -1))

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage } from '@/types/enums/video-diagnostic.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnSupportedBrowser',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).BROWSER_TEST,
    class: _normalizeClass(
      __props.stage === _unref(Stage).BROWSER_TEST || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode(_component_SvgIcon, {
            class: "error-icon-container",
            icon: 'error-sign',
            "inherit-fill": true,
            height: "24"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.browser-un-supported')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('video-diagnostic.chrome-suggestion')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('video-diagnostic.safari-suggestion')), 1)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('video-diagnostic.browser-un-supported-detail')), 1)
      ]),
      _hoisted_6
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})